import { showNotification } from "../../utilities/notification";
import { Popup, PopupButton, PopupPosition } from "../../utilities/popup";
import { showConfirmPopup } from "../../utilities/popup.confirm";
import { getTranslations } from "../../translations";
import { phonenumberHolder } from "../phonenumber";
import { InputValidator } from "../inputvalidator";

export const deleteAddressPopups: Array<DeleteAddressPopup> = [];
export const updateAddressPopups: Array<UpdateAddressPopup> = [];
export const changeAddressPopups: Array<ChangeAddressPopup> = [];
export const createAddressPopups: Array<ChangeAddressPopup> = [];

declare function setValidateAddressEvents(
    addressID: string | number,
    curCountryElement: string | JQuery,
    curStreetElement: JQuery,
    curResidenceElement: JQuery,
    curZipCodeElement: string | JQuery,
    curHouseNumberElement: string | JQuery
): void;


export class UpdateAddressPopup
{
    element: HTMLElement;
    popup: Popup | null = null;

    constructor(element: HTMLElement)
    {
        this.element = element;

        this.attachEvents();
    }

    private attachEvents(): void
    {
        const instance = this;

        $(this.element).off("click.updateAddressPopup");

        $(this.element).on("click.updateAddressPopup", (event) =>
        {
            event.preventDefault();
            event.stopPropagation();
            
            
            if (phoneInput && (phoneInput.error || !phoneInput.iti.isValidNumber())) 
                return;
            
            if (
                $("#firstname").val() !== $("#firstname").attr("value") || 
                $("#lastname").val() !== $("#lastname").attr("value")
            ) 
                instance.openModal();
            else 
                updateAddress(false);
        });
    }

    public openModal = (): void =>
    {
        const instance = this;

        if (!instance.popup)
        {
            const buttons: Array<PopupButton> = [];

            const noButton = new PopupButton();
            noButton.label = "Nee";
            noButton.className = "btn btn-white";
            noButton.closeOnCLick = true;

            noButton.onClick = () => {
                updateAddress(false);
            };

            buttons.push(noButton);

            const yesButton = new PopupButton();
            yesButton.label = "Ja";
            yesButton.className = "btn btn-green";
            yesButton.closeOnCLick = true;

            yesButton.onClick = () =>
            {
                updateAddress(true);
            };

            buttons.push(yesButton);

            instance.popup = new Popup({
                id: "update-address-popup",
                title: "Gegevens wijzigen",
                content: "Wil je deze wijziging ook doorvoeren in je opgeslagen adressen?",
                desktopPosition: PopupPosition.Center,
                mobilePosition: PopupPosition.Drawer,
                closeButton: true,
                buttons: buttons
            });
        }

        instance.popup.show();
    };
}

export class ChangeAddressPopup
{
    element: HTMLElement;
    popup: Popup | null = null;
    addressID: number = 0;
    customerAddressID: number = 0;
    isCreate: boolean = false;

    constructor(element: HTMLElement, isCreate: boolean = false)
    {
        this.element = element;
        this.isCreate = isCreate;

        this.attachEvents();
    }

    private attachEvents(): void
    {
        $(this.element)
            .off("click.changeAddressPopup")
            .on("click.changeAddressPopup", (event) =>
            {
                event.preventDefault();
                event.stopPropagation();

                this.openModal();
            });
    }

    private openModal(): void
    {
        if (this.isCreate)
        {
            this.addressID = 0;
            this.customerAddressID = 0;
        }
        else
        {
            this.addressID = Number(
                $(this.element).data("address-id")
            );

            this.customerAddressID = Number(
                $(this.element).data("customer-address-id")
            );

            if (this.addressID <= 0 || this.customerAddressID <= 0)
                return;
        }

        let url = "/Services/modules/Webshop.asmx/CustomerAddressEditView";

        if (!this.isCreate)
        {
            url += "?addressID=" + this.addressID;
            url += "&customerAddressID=" + this.customerAddressID;
        }

        $.ajax({
            type: "POST",
            url: url,
            dataType: "html",
            success: (data) =>
            {
                if (data == null || data.length <= 0)
                    return;

                const popupID = this.isCreate
                    ? "create-address-popup"
                    : "change-address-popup-" + this.customerAddressID;

                this.popup = new Popup({
                    id: popupID,
                    title: this.isCreate
                        ? getTranslations().txtAddAddress
                        : getTranslations().txtChangeAddress,
                    content: data,
                    popupClass: "g-popup__container--address",
                    desktopPosition: PopupPosition.Right,
                    mobilePosition: PopupPosition.fullScreen,
                    closeButton: true
                });

                this.popup.show();

                this.initForm();
                initInputFields();
            },
            error: (xhr, status, error) =>
            {
                console.error("CustomerAddressEditView fout:", {
                    xhr,
                    status,
                    error
                });
            }
        });
    }

    private initForm(): void
    {
        const popupID = this.isCreate
            ? "#modal-create-address-popup"
            : "#modal-change-address-popup-" + this.customerAddressID;

        const $popup = $(popupID);

        const $saveButton = $popup.find(
            'input[data-tagname="saveaddress"]'
        );

        const $cancelButton = $popup.find("#cancel");

        const $form = $popup.find("form").first();

        $form
            .off("submit.changeAddress")
            .on("submit.changeAddress", (event) =>
            {
                event.preventDefault();
                event.stopPropagation();

                return false;
            });

        $saveButton
            .off("click.changeAddress")
            .on("click.changeAddress", (event) =>
            {
                event.preventDefault();
                event.stopPropagation();

                const addressID = Number(
                    $(event.currentTarget).data("address-id") ?? 0
                );

                const customerAddressID = Number(
                    $(event.currentTarget).data("customer-address-id") ?? 0
                );

                this.saveAddress(
                    addressID,
                    customerAddressID,
                );
            });

        $cancelButton
            .off("click.changeAddress")
            .on("click.changeAddress", (event) =>
            {
                event.preventDefault();
                event.stopPropagation();

                this.popup?.hide();
            });

        let $curCountryElement = $(`[id^=country${this.addressID}]`);
        if ($curCountryElement.length <= 0)
            $curCountryElement = $("[id^=country]");

        let $curStreetElement = $(`[id^=street${this.addressID}]`);
        if ($curStreetElement.length <= 0)
            $curStreetElement = $("[id^=street]");

        let $curResidenceElement = $(`[id^=residence${this.addressID}]`);
        if ($curResidenceElement.length <= 0)
            $curResidenceElement = $("[id^=residence]");

        let $curZipCodeElement = $(`[id^=zipcode${this.addressID}]`);
        if ($curZipCodeElement.length <= 0)
            $curZipCodeElement = $("[id^=zipcode]");

        let $curHouseNumberElement = $(`[id^=housenumber${this.addressID}]`);
        if ($curHouseNumberElement.length <= 0)
            $curHouseNumberElement = $("[id^=housenumber]");

        setValidateAddressEvents(0, $curCountryElement, $curStreetElement, $curResidenceElement, $curZipCodeElement, $curHouseNumberElement);
    }

    private saveAddress(
        addressID: number,
        customerAddressID: number
    ): void
    {
        let url = "/Services/modules/Webshop.asmx/CustomerAddressEditView";

        if (addressID > 0)
        {
            url += "?addressID=" + addressID;

            if (customerAddressID > 0)
                url += "&customerAddressID=" + customerAddressID;
        }

        const popupID = this.isCreate
            ? "#modal-create-address-popup"
            : "#modal-change-address-popup-" + customerAddressID;

        const $popup = $(popupID);

        const $form = addressID > 0
            ? $popup.find("#addressForm" + addressID)
            : $popup.find("form").first();

        $.ajax({
            type: "POST",
            data: $form.serialize(),
            url: url,
            dataType: "html",
            success: (data) =>
            {
                if (data == null || data.length <= 0)
                    return;

                const $data = $("<div>").html(data);

                const $errors = $data.find(
                    ".address-errors .error-messages"
                );

                const hasErrors =
                    $errors.length > 0 &&
                    ($errors.text() ?? "").trim().length > 0;

                if (hasErrors)
                {
                    $popup
                        .find(".g-popup__content")
                        .html(data);

                    this.initForm();

                    const errorHTML = $errors.html();

                    if (errorHTML)
                        console.log(errorHTML);

                    return;
                }

                this.popup?.hide();

                if (this.isCreate)
                {
                    const $newAddress = $data
                        .find(".address-item");

                    $newAddress.find(".change-address-form").remove();

                    if ($newAddress.length > 0)
                    {
                        $newAddress.insertBefore(".new-address-holder");
                    }

                    showNotification({
                        title: "Adres toegevoegd",
                        message: "Je adres is succesvol toegevoegd.",
                        status: "success"
                    });

                    $newAddress.find(".js-delete-address").each((i, element) => {
                        deleteAddressPopups.push(
                            new DeleteAddressPopup(element)
                        );
                    });
                }
                else
                {
                    showNotification({
                        title: "Adres gewijzigd",
                        message: "Je adres is succesvol gewijzigd.",
                        status: "success"
                    });
                }

                // Refresh addresses

                $(".c-order-form__login-address-list").html(data);

                if (this.isCreate)
                {
                    setTimeout(function ()
                    {
                        $(".c-order-form__login-address-list").children().last().trigger("click");
                    }, 1);
                }
            },
            error: (xhr, status, error) =>
            {
                console.error("Adres opslaan fout:", {
                    xhr,
                    status,
                    error
                });
            }
        });
    }
}

export class DeleteAddressPopup
{
    element: HTMLElement;
    popup: Popup | null = null;

    constructor(element: HTMLElement)
    {
        this.element = element;

        this.attachEvents();
    }

    private attachEvents(): void
    {
        $(this.element)
            .off("click.deleteAddressPopup")
            .on("click.deleteAddressPopup", (event) =>
            {
                event.preventDefault();
                event.stopPropagation();

                if ($(".address-item").length <= 1)
                    return;

                const addressID = Number(
                    $(this.element).data("address-id")
                );

                if (addressID <= 0)
                    return;

                this.openModal(addressID);
            });
    }

    private openModal(addressID: number): void
    {
        this.popup = showConfirmPopup({
            id: "delete-address-popup-" + addressID,

            title: "Adres verwijderen",

            content:
                "Weet je zeker dat je dit adres wilt verwijderen?",

            confirmLabel: "Verwijderen",
            confirmClassName: "btn btn-red",

            onConfirm: () =>
            {
                this.deleteAddress(addressID);
            }
        });
    }

    private deleteAddress(addressID: number): void
    {
        if ($(".address-item").length <= 1)
            return;

        const url =
            "/Services/modules/Webshop.asmx/CustomerAddressDeleteDialog?addressID=" +
            addressID +
            "&confirmedDelete=true";

        $.ajax({
            type: "POST",
            url: url,
            dataType: "html",

            success: () =>
            {
                this.popup?.hide();

                $("#addressItem" + addressID)
                    .slideUp(500, function ()
                    {
                        $(this).remove();
                        initAddressDefaults();
                    });

                showNotification({
                    title: "Adres verwijderd",
                    message: "Het adres is succesvol verwijderd.",
                    status: "success"
                });
            },

            error: (xhr, status, error) =>
            {
                console.error(
                    "Adres verwijderen mislukt:",
                    {
                        xhr,
                        status,
                        error
                    }
                );
            }
        });
    }
}

export class CascadeQuestions
{
    private element: HTMLInputElement;

    constructor(element: HTMLInputElement)
    {
        this.element = element;

        this.attachEvents();
    }

    private attachEvents(): void
    {
        this.element.addEventListener("change", () =>
        {
            this.handleChange();
        });
    }

    private handleChange(): void
    {
        if (!this.element.checked)
            return;

        const questionID = this.element.dataset.nextQuestion;

        if (!questionID)
            return;

        const question = document.getElementById(questionID);

        if (!question)
            return;

        question.style.pointerEvents = "all";
        question.style.opacity = "1";
    }
}

export class PreferencesSubmit
{
    private form: HTMLFormElement;
    private submitButton: HTMLButtonElement | null;

    constructor(form: HTMLFormElement)
    {
        this.form = form;

        this.submitButton = this.form.querySelector<HTMLButtonElement>(
            ".c-preferences__submit"
        );

        this.init();
    }

    private init(): void
    {
        if (!this.submitButton)
            return;

        this.submitButton.disabled = true;

        this.attachEvents();
    }

    private attachEvents(): void
    {
        this.form.addEventListener("change", (event) =>
        {
            const target = event.target as HTMLInputElement;

            if (
                !target.matches(
                    ".c-interestquestion__option-input, #chxemail, input[name='delivery']"
                )
            )
                return;

            this.submitButton!.disabled = false;
        });

        this.form.addEventListener("submit", (event) =>
        {
            event.preventDefault();
            event.stopPropagation();

            this.savePreferences();
        });
    }

    private savePreferences(): void
    {
        if (!this.submitButton)
            return;

        this.submitButton.disabled = true;

        $.ajax({
            type: "POST",
            url: this.form.action || window.location.href,
            data: $(this.form).serialize(),
            dataType: "html",

            success: (data) =>
            {
                this.showSuccessNotification();

                this.submitButton!.disabled = true;
            },

            error: (xhr, status, error) =>
            {
                showNotification({
                    message: getTranslations().prefrencesSaved,
                    status: "danger"
                });

                this.submitButton!.disabled = false;
            }
        });
    }

    private showSuccessNotification(): void
    {
        showNotification({
            message: getTranslations().prefrencesSaved,
            status: "success"
        });
    }
}

function savePersonalData(): void
{
    const form = $("#personal-form")[0] as HTMLFormElement | undefined;

    if (!form)
        return;

    $.ajax({
        url: "/Services/Modules/Webshop.asmx/SavePersonalData",
        type: "POST",
        data: new FormData(form),
        dataType: "json",
        processData: false,
        contentType: false,
        success: (response) =>
        {
            const templateResponse =
                response?.templateResponse ?? "";

            if (templateResponse.length > 0)
            {
                const $result = $("<div>").html(templateResponse);

                const $resultErrors = $result.find("#errors");

                if ($resultErrors.length > 0)
                {
                    $("#errors")
                        .empty()
                        .append($resultErrors.html() ?? "");
                }

                const hiddenFields = [
                    "hidden_firstname",
                    "hidden_lastname",
                    "hidden_gender_male",
                    "hidden_gender_female",
                    "hidden_gender_miss"
                ];

                hiddenFields.forEach((fieldID) =>
                {
                    const $resultField =
                        $result.find(
                            ".personal-data-content #" + fieldID
                        );

                    if ($resultField.length > 0)
                    {
                        $(".personal-data-content #" + fieldID)
                            .val($resultField.val());
                    }
                });

                const hasErrors =
                    $result
                        .find("#errors .error-messages")
                        .filter(function ()
                        {
                            return (
                                $(this)
                                    .text()
                                    .trim()
                                    .length > 0
                            );
                        })
                        .length > 0;

                if (hasErrors)
                    return;
            }

            if (
                response?.nameResponse != null &&
                response.nameResponse.length > 0 &&
                $("#complexid a span").length > 0
            )
            {
                const $accountName = $(
                    $("#complexid a span")[0]
                );

                const currentText =
                    $accountName.html() ?? "";

                const introTextIndex =
                    currentText.indexOf(" ");

                const newText =
                    introTextIndex >= 0
                        ? currentText.slice(
                            0,
                            introTextIndex + 1
                        ) + response.nameResponse
                        : response.nameResponse;

                $accountName.html(newText);
            }

            if (
                response?.searchPlaceHolderResponse != null &&
                response.searchPlaceHolderResponse.length > 0
            )
            {
                $(".search-holder input").attr(
                    "placeholder",
                    response.searchPlaceHolderResponse
                );
            }

            showNotification({
                title: "Gegevens gewijzigd",
                message: "Je gegevens zijn succesvol gewijzigd.",
                status: "success"
            });
        },
        error: (xhr, status, error) =>
        {
            console.error("SavePersonalData fout:", {
                xhr,
                status,
                error
            });
        }
    });
}

let phoneInput;

const initIti = () => {
    const errorMsg = document.querySelector("#telError") as HTMLElement;
    document.querySelectorAll("#phonenumber").forEach((input: HTMLInputElement) => {
        const formId = $(input).closest("form").attr("id");

        phoneInput = new phonenumberHolder(
            input,
            errorMsg,
            formId,
            true,
        )
    });
}

const inputFields: InputValidator[] = [];

const initInputFields = () => {
    $("form").each((i, form: HTMLElement) => {
        const id = $(form).attr("id");
        inputFields.push(new InputValidator(id));
    })
}

window.addEventListener("DOMContentLoaded", () => {
    initInputFields();
    initPasswordForm();
    initIti();
})

const updatePassword = () => {
    const $form = $("#change-password-form");

    if (!$form) return;

    $.ajax({
        type: "POST",
        url: "/Services/modules/Webshop.asmx/UpdateCustomerPassword",
        data: $form.serialize(),
        dataType: "json",
        success: (response: string) => {
            $form.find("#errors").empty();
            if (response != "") {
                $form.find("#errors").append(response);
            }
        }
    });
}

const initPasswordForm = () => {
    const submitButton = $("#change-password-form").find(".js-change-password");

    if (!submitButton) return;

    $(submitButton).off("click");
    $(submitButton).on("click", (e) => {
        e.preventDefault();
        updatePassword();
    });
}

function updateAddress(update: boolean): void
{
    const $form = $("#personal-form");

    if ($form)
    {
        $.ajax({
            type: "POST",
            url: "/Services/modules/Webshop.asmx/UpdateCustomerData?updateToAllAddresses=" + update,
            data: $form.serialize(),
            dataType: "json",
            success: (response) =>
            {
                $form.find('#errors').empty();

                if (
                    response != ""
                ) {
                    $form.find('#errors').append(response);
                } else {
                    showNotification({
                        title: "Gegevens gewijzigd",
                        message: "Je gegevens zijn succesvol gewijzigd.",
                        status: "success"
                    });
                }

                initUserAccount();
                reInitUpdateAddressPopup();

                setTimeout(() => {
                    if (update) window.location.reload();
                }, 1000);

                $("#firstname").attr("value", $("#firstname").val().toString());
                $("#lastname").attr("value", $("#lastname").val().toString());
            },
            error: (xhr, status, error) =>
            {
                console.error("UpdateCustomerData fout:", {
                    xhr,
                    status,
                    error
                });
            }
        });
    }
}


function changeAddressType(
    source: HTMLInputElement,
    addressID: number | string
): void
{
    const url =
        "/Services/modules/Webshop.asmx/CustomerAddressEditType" +
        "?customerAddressID=" +
        addressID;

    const $source = $(source);
    const $form = $source.closest("form");
    const formData = $form.serialize();

    $(".address-wrapper").fadeOut(500, () =>
    {
        $(".loading-icon").show();

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            dataType: "html",
            success: (data) =>
            {
                if (data != null && data.length > 0)
                {
                    $(".personal-adress-container").replaceWith(data);
                    $(".loading-icon").hide();

                    reInitUpdateAddressPopup();
                }
                else
                {
                    $(".loading-icon").hide();
                    $(".address-wrapper").show();
                }
            },
            error: (xhr, status, error) =>
            {
                $(".loading-icon").hide();
                $(".address-wrapper").show();

                console.error("CustomerAddressEditType fout:", {
                    xhr,
                    status,
                    error
                });
            }
        });
    });
}

function initAddressDefaults(): void
{
    const $addressItems = $(".address-item");
    const addressCount = $addressItems.length;

    if (addressCount === 0)
        return;

    const deliverySelector =
        'input[data-tagname="toggle-delivery"]';

    const invoiceSelector =
        'input[data-tagname="toggle-invoice"]';

    const $deliveryCheckboxes = $(deliverySelector);
    const $invoiceCheckboxes = $(invoiceSelector);

    if (addressCount === 1)
    {
        $deliveryCheckboxes
            .add($invoiceCheckboxes)
            .prop("checked", true)
            .prop("disabled", true);

        $addressItems
            .find(".address-cbx")
            .addClass("disabled");

        $addressItems
            .find(".js-delete-address")
            .hide();

        return;
    }

    $addressItems
        .find(".js-delete-address")
        .show();

    const bindDefaultAddressType = (selector: string): void =>
    {
        $(selector)
            .off("change.addressDefaults")
            .on("change.addressDefaults", function ()
            {
                const $current = $(this);

                if (!$current.is(":checked"))
                    return;

                $(selector)
                    .not(this)
                    .prop("checked", false)
                    .prop("disabled", false)
                    .closest(".address-cbx")
                    .removeClass("disabled");

                $current
                    .prop("checked", true)
                    .prop("disabled", true)
                    .closest(".address-cbx")
                    .addClass("disabled");
            });
    };

    bindDefaultAddressType(deliverySelector);
    bindDefaultAddressType(invoiceSelector);
}

function initUserAccount(): void
{
    $('.bussines-form').hide();

    $('#status-bussines')
        .off('change.userAccount')
        .on('change.userAccount', () =>
        {
            if ($('#status-bussines').is(':checked'))
                $('.bussines-form').show();
            else
                $('.bussines-form').fadeOut('slow');
        });

    $('#status-private')
        .off('change.userAccount')
        .on('change.userAccount', () =>
        {
            if ($('#status-private').is(':checked'))
                $('.bussines-form').fadeOut('slow');
            else
                $('.bussines-form').show();
        });

    if ($('#status-bussines').is(':checked'))
        $('.bussines-form').show();

    $('.dropdownlist-birthday > div')
        .off('click.userAccount')
        .on('click.userAccount', () =>
        {
            const $currentSelected = $('.select-options').find('.current-selected');

            if ($currentSelected.length > 0)
            {
                $('.drop-list').scrollTop(
                    ($currentSelected[0] as HTMLElement).offsetTop - 100
                );
            }
        });

    initAddressDefaults();
}

export const reInitUpdateAddressPopup = (): void =>
{
    document
        .querySelectorAll<HTMLElement>(".js-update-address")
        .forEach((item) =>
        {
            updateAddressPopups.push(
                new UpdateAddressPopup(item)
            );
        });

    document
        .querySelectorAll<HTMLElement>(".js-change-address")
        .forEach((item) =>
        {
            changeAddressPopups.push(
                new ChangeAddressPopup(item)
            );
        });

    document
        .querySelectorAll<HTMLElement>(".js-add-address")
        .forEach((item) =>
        {
            createAddressPopups.push(
                new ChangeAddressPopup(item, true)
            );
        });

    document
        .querySelectorAll<HTMLElement>(".js-delete-address")
        .forEach((item) =>
        {
            deleteAddressPopups.push(
                new DeleteAddressPopup(item)
            );
        });

    document
        .querySelectorAll<HTMLInputElement>(".js-cascade-question")
        .forEach((element) =>
        {
            new CascadeQuestions(element);
        });

    document
        .querySelectorAll<HTMLFormElement>(".c-preferences__form")
        .forEach((form) =>
        {
            new PreferencesSubmit(form);
        });

    initUserAccount();
};

if (document.readyState === "loading")
{
    document.addEventListener(
        "DOMContentLoaded",
        () => {
            reInitUpdateAddressPopup();
            initInputFields();
        }
    );
}
else
{
    reInitUpdateAddressPopup();
}

(window as any).updateAddressPopups = updateAddressPopups;
(window as any).changeAddressPopups = changeAddressPopups;
(window as any).deleteAddressPopups = deleteAddressPopups;
(window as any).createAddressPopups = createAddressPopups;
(window as any).reInitUpdateAddressPopup = reInitUpdateAddressPopup;
(window as any).changeAddressType = changeAddressType;
